import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { FormBuilder, FormArray, FormGroup, Validators } from '@angular/forms';

import { forkJoin, of, from } from 'rxjs';
import { map, switchMap, bufferCount, concatMap, delay, mergeMap } from 'rxjs/operators';

import { Chart } from 'chart.js/auto';
import { InteractionItem } from 'chart.js/dist/core/core.interaction';
import 'chartjs-adapter-moment';

import { AlertService } from '../../services/alert.service';
import { LoginService } from '../../services/login.service';
import { PairingService } from '../../services/pairing.service';
import { ProgressIndicatorService } from '../../services/progress-indicator.service';
import { TrackingService } from '../../services/tracking.service';
import { UserService } from '../../services/user.service';
@Component({
    selector: 'user-v2',
    templateUrl: './user-v2.component.html',
    styleUrls: ['./user-v2.component.scss']
})
export class UserV2Component implements OnInit, OnDestroy {

    @Input()
    accountId!: string;

    unknownAccountId!: boolean;

    account: any;

    confirmed: any;

    profile: any;

    accountFormGroup!: FormGroup;

    accountAuthorityFormGroup!: FormGroup;

    accountAuthorityFormArray!: FormArray;

    profileFormGroup!: FormGroup;

    devices!: any[] | null;

    trackingDistance!: Chart | null;

    trackingSteps!: Chart | null;

    trackingCalories!: Chart | null;

    trackingDuration!: Chart | null;

    trackingDistanceWeek!: Chart | null;

    trackingStepsWeek!: Chart | null;

    trackingCaloriesWeek!: Chart | null;

    trackingDurationWeek!: Chart | null;

    heartRateYearChart!: Chart | null;

    heartRateWeekChart!: Chart | null;

    bodyTempYearChart!: Chart | null;

    bodyTempWeekChart!: Chart | null;

    sleepChart!: Chart | null;

    sleepWeekChart!: Chart | null;

    hoverEmailStatus!: boolean;

    constructor(
        private alertService: AlertService,
        private progressIndicatorService: ProgressIndicatorService,
        private userService: UserService,
        private loginService: LoginService,
        private pairingService: PairingService,
        private trackingService: TrackingService,
        private formBuilder: FormBuilder
    ) {
    }

    ngOnInit() {

        this.accountFormGroup = this.formBuilder.group({
            accountEmailInput: [{ value: null, disabled: false }, Validators.required],
        });

        this.accountAuthorityFormGroup = this.formBuilder.group({
            accountAuthorityFormArray: this.accountAuthorityFormArray = this.formBuilder.array([])
        });

        this.profileFormGroup = this.formBuilder.group({
            profileFirstNameInput: [{ value: null, disabled: false }, Validators.required],
            profileLastNameInput: [{ value: null, disabled: false }, Validators.required],
            profileNickNameInput: [{ value: null, disabled: false }, Validators.required],
            profileGenderInput: [{ value: null, disabled: false }, Validators.required],
            profileCountryInput: [{ value: null, disabled: false }, Validators.required],
            profileDateOfBirthInput: [{ value: null, disabled: false }, Validators.required],
            profileHeightInput: [{ value: null, disabled: false }, Validators.required],
            profileHeightUnitInput: [{ value: null, disabled: false }, Validators.required],
            profileWeightInput: [{ value: null, disabled: false }, Validators.required],
            profileWeightUnitInput: [{ value: null, disabled: false }, Validators.required]
        });

        this.getAccount();
        this.updateEmailConfirmed();
        this.loadDevices();
    }

    ngOnDestroy() {
    }

    addAccountAuthority() {
        this.accountAuthorityFormArray.push(this.formBuilder.group({
            accountAuthorityInput: [null, Validators.required]
        }));
    }

    removeAuthority(index: number) {
        this.accountAuthorityFormArray.removeAt(index);
    }

    getAccount() {

        let accountId: string = this.accountId.trim();

        this.progressIndicatorService.progress = true;
        forkJoin([
            this.userService.searchByAccountIdV2(accountId),
            this.userService.getV2LastTokenTimes(accountId),
            this.loginService.getProfileByAccountIdV2(accountId),
        ]).subscribe({
            next: ([account, lastTokenTimes, profile]) => {
                console.log('UserComponentV2.getAccount.userService.searchByAccountIdV2.devices', account);
                console.log('UserComponentV2.getAccount.userService.getV2LastTokenTimes.applications', lastTokenTimes);
                console.log('UserComponentV2.getAccount.loginService.getProfileByAccountIdV2.applications', profile);
                this.progressIndicatorService.progress = false;

                this.account = account;
                this.account.lastAccessTokenTime = lastTokenTimes.lastAccessTokenTime;
                this.account.lastRefreshTokenTime = lastTokenTimes.lastRefreshTokenTime;
                this.profile = profile;

                this.accountFormGroup.controls['accountEmailInput'].patchValue(account.email);

                this.profileFormGroup.controls['profileFirstNameInput'].patchValue(profile.firstname);
                this.profileFormGroup.controls['profileLastNameInput'].patchValue(profile.lastname);
                this.profileFormGroup.controls['profileNickNameInput'].patchValue(profile.nickname);
                this.profileFormGroup.controls['profileGenderInput'].patchValue(profile.gender);
                this.profileFormGroup.controls['profileCountryInput'].patchValue(profile.country);
                this.profileFormGroup.controls['profileDateOfBirthInput'].patchValue(profile.dateOfBirth);
                this.profileFormGroup.controls['profileHeightInput'].patchValue(profile.height);
                this.profileFormGroup.controls['profileHeightUnitInput'].patchValue(profile.heightUnit);
                this.profileFormGroup.controls['profileWeightInput'].patchValue(profile.weight);
                this.profileFormGroup.controls['profileWeightUnitInput'].patchValue(profile.weightUnit);

                while (this.accountAuthorityFormArray.length > 0) {
                    this.accountAuthorityFormArray.removeAt(0);
                }

                let authorities: any[] = this.account.authorities;
                authorities.forEach(authority => {
                    this.accountAuthorityFormArray.push(this.formBuilder.group({
                        accountAuthorityInput: [authority, Validators.required]
                    }));
                });

            },
            error: (error: any) => {
                console.log('UserComponentV2.getAccount.userService.forkJoin.error', error);
                this.progressIndicatorService.progress = false;
                this.alertService.danger('Error');

                if (error.status == 404) {
                    this.unknownAccountId = true;
                } else {
                    this.alertService.danger('Error');
                }
            }
        });
    }

    updateEmailConfirmed() {

        let accountId: string = this.accountId.trim();
        this.confirmed = null;

        //this.progressIndicatorService.progress = true;
        this.userService.searchByAccountIdV2(accountId).pipe(
            switchMap((data: any) => {
                if (data.email) {
                    return this.userService.getV2EmailConfirmed(data.email);
                } else {
                    return of({ confirmed: false });
                }
            })
        ).subscribe({
            next: (value: any) => {
                console.log('UserComponentV2.updateEmailConfirmed.userService.getV2EmailConfirmed.value', value);
                // this.progressIndicatorService.progress = false;

                this.confirmed = value.confirmed;
            },
            error: (error: any) => {
                console.log('UserComponentV2.updateEmailConfirmed.userService.getV2EmailConfirmed.error', error);
                // this.progressIndicatorService.progress = false;
                //this.alertService.danger('Error');

                this.confirmed = false;
            }
        });
    }

    saveAccount() {

        let accountId: string = this.accountId.trim();
        let formGroup: FormGroup = this.accountFormGroup;
        let email = formGroup.value.accountEmailInput.trim();

        this.progressIndicatorService.progress = true;
        this.userService.updateV2AccountEmail(accountId, email).subscribe({
            next: (value: any) => {
                console.log('UserComponentV2.saveAccount.userService.updateV2AccountEmail.value', value);
                this.progressIndicatorService.progress = false;
                this.alertService.success('Success');
                this.getAccount();
                this.updateEmailConfirmed();
            },
            error: (error: any) => {
                console.log('UserComponentV2.saveAccount.userService.updateV2AccountEmail.error', error);
                this.progressIndicatorService.progress = false;
                this.alertService.danger('Error');
                this.getAccount();
                this.updateEmailConfirmed();
            }
        });
    }

    saveAccountAuthorities() {

        let accountId: string = this.account.accountId;
        let role: string = this.account.role;

        let formGroup: FormGroup = this.accountAuthorityFormGroup;
        let authorities: string[] = formGroup.value.accountAuthorityFormArray.map((value: any) => value.accountAuthorityInput);

        this.progressIndicatorService.progress = true;
        this.userService.updateV2AccountAuthorities(accountId, role, authorities).subscribe({
            next: (value: any) => {
                console.log('UserComponentV2.saveAccountAuthorities.userService.updateV2AccountAuthorities.value', value);
                this.progressIndicatorService.progress = false;
                this.alertService.success('Success');
                this.getAccount();
                this.updateEmailConfirmed();
            },
            error: (error: any) => {
                console.log('UserComponentV2.saveAccountAuthorities.userService.updateV2AccountAuthorities.error', error);
                this.progressIndicatorService.progress = false;
                this.alertService.danger('Error');
                this.getAccount();
                this.updateEmailConfirmed();
            }
        });
    }

    saveProfile() {

        let accountId: string = this.accountId.trim();
        let formGroup: FormGroup = this.profileFormGroup;

        let profile: any = {};
        profile.firstname = formGroup.value.profileFirstNameInput;
        profile.lastname = formGroup.value.profileLastNameInput;
        profile.nickname = formGroup.value.profileNickNameInput;
        profile.country = formGroup.value.profileCountryInput;
        profile.gender = formGroup.value.profileGenderInput;
        profile.height = formGroup.value.profileHeightInput;
        profile.heightUnit = formGroup.value.profileHeightUnitInput;
        profile.weight = formGroup.value.profileWeightInput;
        profile.weightUnit = formGroup.value.profileWeightUnitInput;
        profile.dateOfBirth = formGroup.value.profileDateOfBirthInput;

        this.progressIndicatorService.progress = true;
        this.userService.updateV2Profile(accountId, profile).subscribe({
            next: (value: any) => {
                console.log('UserComponentV2.saveProfile.userService.updateV2Profile.value', value);
                this.progressIndicatorService.progress = false;
                this.alertService.success('Success');
                this.getAccount();
                this.updateEmailConfirmed();
            },
            error: (error: any) => {
                console.log('UserComponentV2.saveProfile.userService.updateV2Profile.error', error);
                this.progressIndicatorService.progress = false;
                this.alertService.danger('Error');
                this.getAccount();
                this.updateEmailConfirmed();
            }
        });
    }

    loadDevices() {

        this.devices = null;

        this.progressIndicatorService.progress = true;
        this.pairingService.getAllDevicesByAccountIdV2(this.accountId).subscribe({
            next: (value: any) => {
                console.log('UserComponentV2.loadDevices.pairingService.getAllDevicesByAccountIdV2.value', value);
                this.progressIndicatorService.progress = false;
                // this.alertService.success('Success');

                this.devices = value.devices.sort((a: any, b: any) => b.updateDatetime - a.updateDatetime);

                from(value.devices)
                    .pipe(
                        bufferCount(3),
                        concatMap(data => of(data).pipe(delay(333))),
                        mergeMap(data => data)
                    )
                    .subscribe(
                        (value: any) => {
                            let device = value;
                            let accountId = device.accountId;
                            let serialNumber = device.serialNumber;
                            this.pairingService.getV2FirmwaresByDevice(accountId, serialNumber).subscribe({
                                next: (value: any) => {
                                    console.log('UserComponentV2.loadDevices.pairingService.getV2FirmwaresByDevice.value', value);
                                    let firmwares = value && value.firmwares ? value.firmwares : [];
                                    if (device.product == 'MyScale') {
                                        firmwares.forEach((firmware: any) => {
                                            firmware.version = firmware.version.split('.')[0];
                                        });
                                    }
                                    device.firmwares = firmwares;
                                },
                                error: (error: any) => {
                                    console.log('UserComponentV2.loadDevices.pairingService.getV2FirmwaresByDevice.error', error);
                                }
                            });
                        });
            },
            error: (error: any) => {
                console.log('UserComponentV2.loadDevices.pairingService.getAllDevicesByAccountIdV2.error', error);
                this.progressIndicatorService.progress = false;
                this.alertService.danger('Error');
            }
        });
    }

    loadTrackingData() {

        [this.trackingSteps, this.trackingDistance, this.trackingCalories, this.trackingDuration,
        this.trackingStepsWeek, this.trackingDistanceWeek, this.trackingCaloriesWeek, this.trackingDurationWeek]
            .filter(chart => chart != null)
            .forEach(chart => chart?.destroy());

        let d: Date = new Date(Date.now());
        d = new Date(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
        d.setMonth(d.getMonth() + 1);
        let maxDate: Date = new Date(d);
        d.setMonth(d.getMonth() - 12);
        let minDate: Date = new Date(d);

        let createChart = (id: string, data: any, backgroundColor: string, label: string, displayTitle: boolean) => new Chart(id, {
            type: 'bar',
            data: {
                datasets: [{
                    data: data,
                    backgroundColor: backgroundColor,
                    label: label,
                    maxBarThickness: 2,
                }]
            },
            options: {
                animation: false,
                maintainAspectRatio: false,
                plugins: {
                    title: {
                        display: displayTitle,
                        text: 'Year View',
                    }
                },
                scales: {
                    x: {
                        type: 'time',
                        time: {
                            displayFormats: {
                                month: 'YYYY MMM'
                            },
                            tooltipFormat: 'YYYY-MM-DD',
                            unit: 'month',
                        },
                        min: minDate + '',
                        max: maxDate + '',
                        grid: {
                            offset: false
                        },
                    },
                    y: {
                        beginAtZero: true,
                        position: 'right',
                        ticks: {
                            mirror: true,
                        }
                    }
                }
            }
        });

        this.progressIndicatorService.progress = true;
        forkJoin(
            ['calorie', 'distance', 'duration', 'step'].map(dataType => {
                return this.trackingService.getV2TrackingDataOfYearByDay(this.accountId, dataType, maxDate.getUTCFullYear()).pipe(
                    switchMap((switchData: any) => {
                        return this.trackingService.getV2TrackingDataOfYearByDay(this.accountId, dataType, maxDate.getUTCFullYear() - 1).pipe(
                            map((data: any) => {
                                switchData.data = data.data.concat(switchData.data).filter((data: any) => {
                                    let day = new Date(data.day);
                                    day = new Date(day.getUTCFullYear(), day.getUTCMonth(), day.getUTCDate());
                                    return minDate <= day && day <= maxDate;
                                })
                                return switchData;
                            })
                        )
                    })
                )
            })
        ).subscribe({
            next: ([calorie, distance, duration, step]) => {
                console.log('UserComponentV2.loadTrackingData.trackingService.getV2TrackingDataOfYearByDay.calorie', calorie);
                console.log('UserComponentV2.loadTrackingData.trackingService.getV2TrackingDataOfYearByDay.distance', distance);
                console.log('UserComponentV2.loadTrackingData.trackingService.getV2TrackingDataOfYearByDay.duration', duration);
                console.log('UserComponentV2.loadTrackingData.trackingService.getV2TrackingDataOfYearByDay.step', step);
                this.progressIndicatorService.progress = false;
                //this.alertService.success('Success');

                let trackingCaloriesData = calorie.data.map((item: any) => ({ x: new Date(item.day), y: item.value }));
                let trackingDistanceData = distance.data.map((item: any) => ({ x: new Date(item.day), y: item.value }));
                let trackingDurationData = duration.data.map((item: any) => ({ x: new Date(item.day), y: item.value }));
                let trackingStepsData = step.data.map((item: any) => ({ x: new Date(item.day), y: item.value }));

                this.trackingDistance = createChart('trackingDistance', trackingDistanceData, '#009933', 'DISTANCE (meters)', false);
                this.trackingSteps = createChart('trackingSteps', trackingStepsData, '#FFCC00', 'STEPS (steps)', true);
                this.trackingCalories = createChart('trackingCalories', trackingCaloriesData, '#990000', 'CALORIES (calories)', false);
                this.trackingDuration = createChart('trackingDuration', trackingDurationData, '#003399', 'DURATION (seconds)', false);

                this.loadTrackingWeekData(new Date(Date.now()));

            },
            error: (error: any) => {
                console.log('UserComponentV2.loadTrackingData.trackingService.forkJoin.error', error);
                this.progressIndicatorService.progress = false;
                this.alertService.danger('Error');
            }
        });
    }

    trackingStepsClick(event: any) {
        this.trackingDataChartClick(this.trackingSteps?.getElementsAtEventForMode(event, 'nearest', {}, true));
    }

    trackingDistanceClick(event: any) {
        this.trackingDataChartClick(this.trackingDistance?.getElementsAtEventForMode(event, 'nearest', {}, true));
    }

    trackingCaloriesClick(event: any) {
        this.trackingDataChartClick(this.trackingCalories?.getElementsAtEventForMode(event, 'nearest', {}, true));
    }

    trackingDurationClick(event: any) {
        this.trackingDataChartClick(this.trackingDuration?.getElementsAtEventForMode(event, 'nearest', {}, true));
    }

    trackingStepsWeekClick(event: any) {
        this.trackingDataChartClick(this.trackingStepsWeek?.getElementsAtEventForMode(event, 'nearest', {}, true));
    }

    trackingDistanceWeekClick(event: any) {
        this.trackingDataChartClick(this.trackingDistanceWeek?.getElementsAtEventForMode(event, 'nearest', {}, true));
    }

    trackingCaloriesWeekClick(event: any) {
        this.trackingDataChartClick(this.trackingCaloriesWeek?.getElementsAtEventForMode(event, 'nearest', {}, true));
    }

    trackingDurationWeekClick(event: any) {
        this.trackingDataChartClick(this.trackingDurationWeek?.getElementsAtEventForMode(event, 'nearest', {}, true));
    }

    trackingDataChartClick(elements: any) {
        if (elements.length > 0) {
            let date: Date = elements[0].element.$context.raw.x;
            this.trackingStepsWeek?.destroy();
            this.trackingDistanceWeek?.destroy();
            this.trackingCaloriesWeek?.destroy();
            this.trackingDurationWeek?.destroy();
            this.trackingStepsWeek = null;
            this.trackingDistanceWeek = null;
            this.trackingCaloriesWeek = null;
            this.trackingDurationWeek = null;
            this.loadTrackingWeekData(date);
        }
    }

    loadTrackingWeekData(date: Date) {

        [this.trackingStepsWeek, this.trackingDistanceWeek, this.trackingCaloriesWeek, this.trackingDurationWeek]
            .filter(chart => chart != null)
            .forEach(chart => chart?.destroy());

        let d: Date = new Date(date);
        d = new Date(d.getFullYear(), d.getMonth(), d.getDate());
        d.setDate(d.getDate() - 3);

        let pad = (s: number, n: number) => '0'.repeat(n).concat(s.toString()).slice(-Math.max(n, s.toString().length));

        let fromDate: string = `${pad(d.getFullYear(), 4)}-${pad(d.getMonth() + 1, 2)}-${pad(d.getDate(), 2)}`;

        d.setDate(d.getDate() + 7);
        let toDate: string = `${pad(d.getFullYear(), 4)}-${pad(d.getMonth() + 1, 2)}-${pad(d.getDate(), 2)}`;

        let minDate: string = fromDate;

        d.setDate(d.getDate() - 1);
        let maxDate: string = `${pad(d.getFullYear(), 4)}-${pad(d.getMonth() + 1, 2)}-${pad(d.getDate(), 2)}`;

        let createChart = (id: string, data: any, backgroundColor: string, label: string, displayTitle: boolean) => new Chart(id, {
            type: 'bar',
            data: {
                datasets: [{
                    data: data,
                    backgroundColor: backgroundColor,
                    label: label,
                    maxBarThickness: 5,
                }]
            },
            options: {
                animation: false,
                maintainAspectRatio: false,
                plugins: {
                    title: {
                        display: displayTitle,
                        text: 'Week View',
                    }
                },
                scales: {
                    x: {
                        type: 'time',
                        time: {
                            displayFormats: {
                                day: 'MMM DD'
                            },
                            tooltipFormat: 'YYYY-MM-DD HH:mm',
                            unit: 'day',
                        },
                        min: minDate + 'T00:00:00.000',
                        max: maxDate + 'T23:59:59.999',
                        grid: {
                            offset: false
                        },
                    },
                    y: {
                        beginAtZero: true,
                        position: 'right',
                        ticks: {
                            mirror: true,
                        }
                    }
                }
            }
        });

        this.progressIndicatorService.progress = true;
        forkJoin(
            ['calorie', 'distance', 'duration', 'step'].map(dataType => this.trackingService.getV2TrackingDataOfWeekByHour(this.accountId, dataType, minDate))
        ).subscribe({
            next: ([calorie, distance, duration, step]) => {
                console.log('UserComponentV2.loadTrackingWeekData.trackingService.getV2TrackingDataOfWeekByHour.calorie', calorie);
                console.log('UserComponentV2.loadTrackingWeekData.trackingService.getV2TrackingDataOfWeekByHour.distance', distance);
                console.log('UserComponentV2.loadTrackingWeekData.trackingService.getV2TrackingDataOfWeekByHour.duration', duration);
                console.log('UserComponentV2.loadTrackingWeekData.trackingService.getV2TrackingDataOfWeekByHour.step', step);
                this.progressIndicatorService.progress = false;
                //this.alertService.success('Success');

                let trackingDistanceData: any[] = [];
                let trackingStepsData: any[] = [];
                let trackingCaloriesData: any[] = [];
                let trackingDurationData: any[] = [];

                let convert = (input: any, output: any[]) => {
                    let data: any;
                    for (data of input.data) {
                        for (let i = 0; i < data.values.length; i++) {
                            let date: Date = new Date(Date.parse(data.day));
                            date.setHours(i);
                            date.setMinutes(0);
                            let x: Date = date;
                            let y: number = data.values[i];
                            let point = { x: x, y: y };
                            output.push(point);
                        }
                    }
                };

                convert(distance, trackingDistanceData);
                convert(step, trackingStepsData);
                convert(calorie, trackingCaloriesData);
                convert(duration, trackingDurationData);

                this.trackingDistanceWeek = createChart('trackingDistanceWeek', trackingDistanceData, '#009933', 'DISTANCE (meters)', false);
                this.trackingStepsWeek = createChart('trackingStepsWeek', trackingStepsData, '#FFCC00', 'STEPS (steps)', true);
                this.trackingCaloriesWeek = createChart('trackingCaloriesWeek', trackingCaloriesData, '#990000', 'CALORIES (calories)', false);
                this.trackingDurationWeek = createChart('trackingDurationWeek', trackingDurationData, '#003399', 'DURATION (seconds)', false);

            }, error: (error: any) => {
                console.log('UserComponentV2.loadHeartRateWeekData.trackingService.forkJoin.error', error);
                this.progressIndicatorService.progress = false;
                this.alertService.danger('Error');
            }
        });
    }

    loadHeartRateData() {

        [this.heartRateYearChart, this.heartRateWeekChart]
            .filter(chart => chart != null)
            .forEach(chart => chart?.destroy());

        let d: Date = new Date(Date.now());
        d = new Date(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
        d.setMonth(d.getMonth() + 1);
        let maxDate: Date = new Date(d);
        d.setMonth(d.getMonth() - 12);
        let minDate: Date = new Date(d);

        let createChart = (id: string, data: any, backgroundColor: string, label: string) => new Chart(id, {
            type: 'line',
            data: {
                datasets: [{
                    data: data,
                    backgroundColor: backgroundColor,
                    borderColor: backgroundColor,
                    label: label,
                    showLine: false,
                    fill: false,
                    pointStyle: 'cross',
                    pointBackgroundColor: backgroundColor,
                    pointBorderColor: backgroundColor,
                }]
            },
            options: {
                animation: false,
                maintainAspectRatio: false,
                plugins: {
                    title: {
                        display: true,
                        text: 'Year View',
                    }
                },
                scales: {
                    x: {
                        type: 'time',
                        time: {
                            displayFormats: {
                                month: 'YYYY MMM'
                            },
                            tooltipFormat: 'YYYY-MM-DD',
                            unit: 'month',
                        },
                        min: minDate + '',
                        max: maxDate + '',
                    },
                    y: {
                        beginAtZero: true,
                        position: 'right',
                        ticks: {
                            mirror: true,
                        }
                    }
                }
            }
        });

        this.progressIndicatorService.progress = true;
        forkJoin(
            ['heartrate'].map(dataType => {
                return this.trackingService.getV2TrackingDataOfYearByDay(this.accountId, dataType, maxDate.getUTCFullYear()).pipe(
                    switchMap((switchData: any) => {
                        return this.trackingService.getV2TrackingDataOfYearByDay(this.accountId, dataType, maxDate.getUTCFullYear() - 1).pipe(
                            map((data: any) => {
                                switchData.data = data.data.concat(switchData.data).filter((data: any) => {
                                    let day = new Date(data.day);
                                    day = new Date(day.getUTCFullYear(), day.getUTCMonth(), day.getUTCDate());
                                    return minDate <= day && day <= maxDate;
                                })
                                return switchData;
                            })
                        )
                    })
                )
            })
        ).subscribe({
            next: ([heartrate]) => {
                console.log('UserComponentV2.loadHeartRateData.trackingService.getV2TrackingDataOfYearByDay.heartrate', heartrate);
                this.progressIndicatorService.progress = false;
                //this.alertService.success('Success');

                let heartRateYearData = heartrate.data.map((item: any) => ({ x: new Date(item.day), y: item.value }));

                this.heartRateYearChart = createChart('heartRateYearChart', heartRateYearData, '#990000', 'HEARTRATE (bpm)');

                this.loadHeartRateWeekData(new Date(Date.now()));

            },
            error: (error: any) => {
                console.log('UserComponentV2.loadHeartRateData.trackingService.forkJoin.error', error);
                this.progressIndicatorService.progress = false;
                this.alertService.danger('Error');
            }
        });
    }

    heartRateYearChartClick(event: any) {
        this.heartRateChartClick(this.heartRateYearChart?.getElementsAtEventForMode(event, 'nearest', {}, true));
    }

    heartRateWeekChartClick(event: any) {
        this.heartRateChartClick(this.heartRateWeekChart?.getElementsAtEventForMode(event, 'nearest', {}, true));
    }

    heartRateChartClick(elements: any) {
        if (elements.length > 0) {
            let date: Date = elements[0].element.$context.raw.x;
            this.heartRateWeekChart?.destroy();
            this.heartRateWeekChart = null;
            this.loadHeartRateWeekData(date);
        }
    }

    loadHeartRateWeekData(date: Date) {

        [this.heartRateWeekChart]
            .filter(chart => chart != null)
            .forEach(chart => chart?.destroy());

        let d: Date = new Date(date);
        d = new Date(d.getFullYear(), d.getMonth(), d.getDate());
        d.setDate(d.getDate() - 3);

        let pad = (s: number, n: number) => '0'.repeat(n).concat(s.toString()).slice(-Math.max(n, s.toString().length));

        let days: string[] = [];
        for (let i = 0; i < 7; i++) {
            days[i] = `${pad(d.getFullYear(), 4)}-${pad(d.getMonth() + 1, 2)}-${pad(d.getDate(), 2)}`;
            d.setDate(d.getDate() + 1);
        }

        let createChart = (id: string, data: any, backgroundColor: string, label: string) => new Chart(id, {
            type: 'line',
            data: {
                datasets: [{
                    data: data,
                    backgroundColor: backgroundColor,
                    borderColor: backgroundColor,
                    label: label,
                    showLine: false,
                    fill: false,
                    pointStyle: 'cross',
                    pointBackgroundColor: backgroundColor,
                    pointBorderColor: backgroundColor,
                }]
            },
            options: {
                animation: false,
                maintainAspectRatio: false,
                plugins: {
                    title: {
                        display: true,
                        text: 'Week View',
                    }
                },
                scales: {
                    x: {
                        type: 'time',
                        time: {
                            displayFormats: {
                                day: 'MMM DD'
                            },
                            tooltipFormat: 'YYYY-MM-DD HH:mm',
                            unit: 'day',
                        },
                        min: days[0] + 'T00:00:00.000',
                        max: days[6] + 'T23:59:59.999',
                    },
                    y: {
                        beginAtZero: true,
                        position: 'right',
                        ticks: {
                            mirror: true,
                        }
                    }
                }
            }
        });

        this.progressIndicatorService.progress = true;
        forkJoin([
            this.trackingService.getV2TrackingDataOfDayBy5Minutes(this.accountId, 'heartrate', days[0]),
            this.trackingService.getV2TrackingDataOfDayBy5Minutes(this.accountId, 'heartrate', days[1]),
            this.trackingService.getV2TrackingDataOfDayBy5Minutes(this.accountId, 'heartrate', days[2]),
            this.trackingService.getV2TrackingDataOfDayBy5Minutes(this.accountId, 'heartrate', days[3]),
            this.trackingService.getV2TrackingDataOfDayBy5Minutes(this.accountId, 'heartrate', days[4]),
            this.trackingService.getV2TrackingDataOfDayBy5Minutes(this.accountId, 'heartrate', days[5]),
            this.trackingService.getV2TrackingDataOfDayBy5Minutes(this.accountId, 'heartrate', days[6]),
        ]).subscribe({
            next: ([day0, day1, day2, day3, day4, day5, day6]) => {
                console.log('UserComponentV2.loadHeartRateWeekData.trackingService.getV2TrackingDataOfDayBy5Minutes.value', day0);
                console.log('UserComponentV2.loadHeartRateWeekData.trackingService.getV2TrackingDataOfDayBy5Minutes.value', day1);
                console.log('UserComponentV2.loadHeartRateWeekData.trackingService.getV2TrackingDataOfDayBy5Minutes.value', day2);
                console.log('UserComponentV2.loadHeartRateWeekData.trackingService.getV2TrackingDataOfDayBy5Minutes.value', day3);
                console.log('UserComponentV2.loadHeartRateWeekData.trackingService.getV2TrackingDataOfDayBy5Minutes.value', day4);
                console.log('UserComponentV2.loadHeartRateWeekData.trackingService.getV2TrackingDataOfDayBy5Minutes.value', day5);
                console.log('UserComponentV2.loadHeartRateWeekData.trackingService.getV2TrackingDataOfDayBy5Minutes.value', day6);
                this.progressIndicatorService.progress = false;
                //this.alertService.success('Success');

                let heartRateWeekData = [];
                for (let day of [day0, day1, day2, day3, day4, day5, day6]) {
                    let data: any;
                    for (data of day.data) {
                        for (let i = 0; i < data.values.length; i++) {
                            let date: Date = new Date(Date.parse(data.day));
                            date.setHours(0);
                            date.setMinutes(i * 5);
                            let x: Date = date;
                            let y: number = data.values[i];
                            let point = { x: x, y: y };
                            heartRateWeekData.push(point);
                        }
                    }
                }

                this.heartRateWeekChart = createChart('heartRateWeekChart', heartRateWeekData, '#990000', 'HEARTRATE (bpm)');

            },
            error: (error: any) => {
                console.log('UserComponentV2.loadHeartRateWeekData.trackingService.forkJoin.error', error);
                this.progressIndicatorService.progress = false;
                this.alertService.danger('Error');
            }
        });
    }

    loadBodyTempData() {

        [this.bodyTempYearChart, this.bodyTempWeekChart]
            .filter(chart => chart != null)
            .forEach(chart => chart?.destroy());

        let d: Date = new Date(Date.now());
        d = new Date(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
        d.setMonth(d.getMonth() + 1);
        let maxDate: Date = new Date(d);
        d.setMonth(d.getMonth() - 12);
        let minDate: Date = new Date(d);

        let createChart = (id: string, data: any, backgroundColor: string, label: string) => new Chart(id, {
            type: 'line',
            data: {
                datasets: [{
                    data: data,
                    backgroundColor: backgroundColor,
                    borderColor: backgroundColor,
                    label: label,
                    showLine: false,
                    fill: false,
                    pointStyle: 'cross',
                    pointBackgroundColor: backgroundColor,
                    pointBorderColor: backgroundColor,
                }]
            },
            options: {
                animation: false,
                maintainAspectRatio: false,
                plugins: {
                    title: {
                        display: true,
                        text: 'Year View',
                    }
                },
                scales: {
                    x: {
                        type: 'time',
                        time: {
                            displayFormats: {
                                month: 'YYYY MMM'
                            },
                            tooltipFormat: 'YYYY-MM-DD',
                            unit: 'month',
                        },
                        min: minDate + '',
                        max: maxDate + '',
                    },
                    y: {
                        beginAtZero: true,
                        position: 'right',
                        ticks: {
                            mirror: true,
                        }
                    }
                }
            }
        });

        this.progressIndicatorService.progress = true;
        forkJoin(
            ['bodytemp'].map(dataType => {
                return this.trackingService.getV2TrackingDataOfYearByDay(this.accountId, dataType, maxDate.getUTCFullYear()).pipe(
                    switchMap((switchData: any) => {
                        return this.trackingService.getV2TrackingDataOfYearByDay(this.accountId, dataType, maxDate.getUTCFullYear() - 1).pipe(
                            map((data: any) => {
                                switchData.data = data.data.concat(switchData.data).filter((data: any) => {
                                    let day = new Date(data.day);
                                    day = new Date(day.getUTCFullYear(), day.getUTCMonth(), day.getUTCDate());
                                    return minDate <= day && day <= maxDate;
                                })
                                return switchData;
                            })
                        )
                    })
                )
            })
        ).subscribe({
            next: ([bodytemp]) => {
                console.log('UserComponentV2.loadBodyTempData.trackingService.getLastYearBodyTempData.bodytemp', bodytemp);
                this.progressIndicatorService.progress = false;
                //this.alertService.success('Success');

                let bodyTempYearData = bodytemp.data.map((item: { day: string | number | Date; value: any; }) => ({ x: new Date(item.day), y: item.value }));

                this.bodyTempYearChart = createChart('bodyTempYearChart', bodyTempYearData, '#990000', 'BODYTEMP (celsius)');

                this.loadBodyTempWeekData(new Date(Date.now()));

            },
            error: (error: any) => {
                console.log('UserComponentV2.loadBodyTempData.trackingService.forkJoin.error', error);
                this.progressIndicatorService.progress = false;
                this.alertService.danger('Error');
            }
        });
    }

    bodyTempYearChartClick(event: any) {
        this.bodyTempChartClick(this.bodyTempYearChart?.getElementsAtEventForMode(event, 'nearest', {}, true));
    }

    bodyTempWeekChartClick(event: any) {
        this.bodyTempChartClick(this.bodyTempWeekChart?.getElementsAtEventForMode(event, 'nearest', {}, true));
    }

    bodyTempChartClick(elements: any) {
        if (elements.length > 0) {
            let date: Date = elements[0].element.$context.raw.x;
            this.bodyTempWeekChart?.destroy();
            this.bodyTempWeekChart = null;
            this.loadBodyTempWeekData(date);
        }
    }

    loadBodyTempWeekData(date: Date) {

        [this.bodyTempWeekChart]
            .filter(chart => chart != null)
            .forEach(chart => chart?.destroy());

        let d: Date = new Date(date);
        d = new Date(d.getFullYear(), d.getMonth(), d.getDate());
        d.setDate(d.getDate() - 3);

        let pad = (s: number, n: number) => '0'.repeat(n).concat(s.toString()).slice(-Math.max(n, s.toString().length));

        let days: string[] = [];
        for (let i = 0; i < 7; i++) {
            days[i] = `${pad(d.getFullYear(), 4)}-${pad(d.getMonth() + 1, 2)}-${pad(d.getDate(), 2)}`;
            d.setDate(d.getDate() + 1);
        }

        let createChart = (id: string, data: any, backgroundColor: string, label: string) => new Chart(id, {
            type: 'line',
            data: {
                datasets: [{
                    data: data,
                    backgroundColor: backgroundColor,
                    borderColor: backgroundColor,
                    label: label,
                    showLine: false,
                    fill: false,
                    pointStyle: 'cross',
                    pointBackgroundColor: backgroundColor,
                    pointBorderColor: backgroundColor,
                }]
            },
            options: {
                animation: false,
                maintainAspectRatio: false,
                plugins: {
                    title: {
                        display: true,
                        text: 'Week View',
                    }
                },
                scales: {
                    x: {
                        type: 'time',
                        time: {
                            displayFormats: {
                                day: 'MMM DD'
                            },
                            tooltipFormat: 'YYYY-MM-DD HH:mm',
                            unit: 'day',
                        },
                        min: days[0] + 'T00:00:00.000',
                        max: days[6] + 'T23:59:59.999',
                    },
                    y: {
                        beginAtZero: true,
                        position: 'right',
                        ticks: {
                            mirror: true,
                        }
                    }
                }
            }
        });

        this.progressIndicatorService.progress = true;
        forkJoin([
            this.trackingService.getV2TrackingDataOfDayBy5Minutes(this.accountId, 'bodytemp', days[0]),
            this.trackingService.getV2TrackingDataOfDayBy5Minutes(this.accountId, 'bodytemp', days[1]),
            this.trackingService.getV2TrackingDataOfDayBy5Minutes(this.accountId, 'bodytemp', days[2]),
            this.trackingService.getV2TrackingDataOfDayBy5Minutes(this.accountId, 'bodytemp', days[3]),
            this.trackingService.getV2TrackingDataOfDayBy5Minutes(this.accountId, 'bodytemp', days[4]),
            this.trackingService.getV2TrackingDataOfDayBy5Minutes(this.accountId, 'bodytemp', days[5]),
            this.trackingService.getV2TrackingDataOfDayBy5Minutes(this.accountId, 'bodytemp', days[6]),
        ]).subscribe({
            next: ([day0, day1, day2, day3, day4, day5, day6]) => {
                console.log('UserComponentV2.loadBodyTempWeekData.trackingService.getV2TrackingDataOfDayBy5Minutes.value', day0);
                console.log('UserComponentV2.loadBodyTempWeekData.trackingService.getV2TrackingDataOfDayBy5Minutes.value', day1);
                console.log('UserComponentV2.loadBodyTempWeekData.trackingService.getV2TrackingDataOfDayBy5Minutes.value', day2);
                console.log('UserComponentV2.loadBodyTempWeekData.trackingService.getV2TrackingDataOfDayBy5Minutes.value', day3);
                console.log('UserComponentV2.loadBodyTempWeekData.trackingService.getV2TrackingDataOfDayBy5Minutes.value', day4);
                console.log('UserComponentV2.loadBodyTempWeekData.trackingService.getV2TrackingDataOfDayBy5Minutes.value', day5);
                console.log('UserComponentV2.loadBodyTempWeekData.trackingService.getV2TrackingDataOfDayBy5Minutes.value', day6);
                this.progressIndicatorService.progress = false;
                //this.alertService.success('Success');

                let bodyTempWeekData = [];
                for (let day of [day0, day1, day2, day3, day4, day5, day6]) {
                    let data: any;
                    for (data of day.data) {
                        for (let i = 0; i < data.values.length; i++) {
                            let date: Date = new Date(Date.parse(data.day));
                            date.setHours(0);
                            date.setMinutes(i * 5);
                            let x: Date = date;
                            let y: number = data.values[i];
                            let point = { x: x, y: y };
                            bodyTempWeekData.push(point);
                        }
                    }
                }

                this.bodyTempWeekChart = createChart('bodyTempWeekChart', bodyTempWeekData, '#990000', 'BODYTEMP (celsius)');

            },
            error: (error: any) => {
                console.log('UserComponentV2.loadBodyTempWeekData.trackingService.forkJoin.error', error);
                this.progressIndicatorService.progress = false;
                this.alertService.danger('Error');
            }
        });
    }

    loadSleepData() {

        [this.sleepChart, this.sleepWeekChart]
            .filter(chart => chart != null)
            .forEach(chart => chart?.destroy());

        let d: Date = new Date(Date.now());
        d = new Date(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
        d.setMonth(d.getMonth() + 1);
        let maxDate: Date = new Date(d);
        d.setMonth(d.getMonth() - 12);
        let minDate: Date = new Date(d);

        let pad = (s: number, n: number) => '0'.repeat(n).concat(s.toString()).slice(-Math.max(n, s.toString().length));

        let months: string[] = [];
        d = new Date(minDate);
        while (d < maxDate) {
            months.push(`${pad(d.getFullYear(), 4)}-${pad(d.getMonth() + 1, 2)}`);
            d.setDate(d.getDate() + 1);
        }
        months = Array.from(new Set(months));

        let createChart = (id: string, data: any) => new Chart(id, {
            type: 'bar',
            data: {
                datasets: [{
                    data: data.map((item: any) => ({ x: item.x, y: item.y.deepDuration })),
                    backgroundColor: '#2077a2',
                    label: 'DEEP (minutes)',
                    maxBarThickness: 2
                },
                {
                    data: data.map((item: any) => ({ x: item.x, y: item.y.lightDuration })),
                    backgroundColor: '#29a5e5',
                    label: 'LIGHT (minutes)',
                    maxBarThickness: 2
                },
                {
                    data: data.map((item: any) => ({ x: item.x, y: item.y.awakeDuration })),
                    backgroundColor: '#d270c3',
                    label: 'AWAKE (minutes)',
                    maxBarThickness: 2
                }]
            },
            options: {
                animation: false,
                maintainAspectRatio: false,
                plugins: {
                    title: {
                        display: true,
                        text: 'Year View',
                    },
                    tooltip: {
                        mode: 'x'
                    }
                },
                scales: {
                    x: {
                        type: 'time',
                        time: {
                            displayFormats: {
                                month: 'YYYY MMM'
                            },
                            tooltipFormat: 'YYYY-MM-DD',
                            unit: 'month',
                        },
                        min: minDate + '',
                        max: maxDate + '',
                        grid: {
                            offset: false
                        },
                        stacked: true,
                    },
                    y: {
                        beginAtZero: true,
                        position: 'right',
                        ticks: {
                            mirror: true,
                        },
                        stacked: true,
                    }
                }
            }
        });

        this.progressIndicatorService.progress = true;
        forkJoin(
            months.map(month => this.trackingService.getV2SleepSummaryOfMonth(this.accountId, month))
        ).subscribe({
            next: (sleepMonths) => {
                console.log('UserComponentV2.loadSleepData.trackingService.getV2SleepSummaryOfMonth.value', sleepMonths);
                this.progressIndicatorService.progress = false;
                //this.alertService.success('Success');

                let sleepData = [];
                for (let sleepMonth of sleepMonths) {
                    for (let sleepDay of sleepMonth.data) {
                        sleepData.push({ x: new Date(sleepDay.day), y: { deepDuration: Math.round(sleepDay.summary.deep / 60), lightDuration: Math.round(sleepDay.summary.light / 60), awakeDuration: Math.round(sleepDay.summary.awake / 60) } });
                    }
                }

                this.sleepChart = createChart('sleepChart', sleepData);

                this.loadSleepWeekData(new Date(Date.now()));

            },
            error: (error: any) => {
                console.log('UserComponentV2.loadSleepData.trackingService.forkJoin.error', error);
                this.progressIndicatorService.progress = false;
                this.alertService.danger('Error');
            }
        });
    }

    sleepYearChartClick(event: any) {
        this.sleepChartClick(this.sleepChart?.getElementsAtEventForMode(event, 'nearest', {}, true));
    }

    sleepWeekChartClick(event: any) {
        this.sleepChartClick(this.sleepWeekChart?.getElementsAtEventForMode(event, 'nearest', {}, true));
    }

    sleepChartClick(elements: any) {
        if (elements.length > 0) {
            let date: Date = elements[0].element.$context.raw.x;
            this.sleepWeekChart?.destroy();
            this.sleepWeekChart = null;
            this.loadSleepWeekData(date);
        }
    }

    loadSleepWeekData(date: Date) {

        [this.sleepWeekChart]
            .filter(chart => chart != null)
            .forEach(chart => chart?.destroy());

        let d: Date = new Date(date);
        d = new Date(d.getFullYear(), d.getMonth(), d.getDate());
        d.setDate(d.getDate() - 3);

        let pad = (s: number, n: number) => '0'.repeat(n).concat(s.toString()).slice(-Math.max(n, s.toString().length));

        let fromDate: string = `${pad(d.getFullYear(), 4)}-${pad(d.getMonth() + 1, 2)}-${pad(d.getDate(), 2)}`;

        d.setDate(d.getDate() + 7);
        let toDate: string = `${pad(d.getFullYear(), 4)}-${pad(d.getMonth() + 1, 2)}-${pad(d.getDate(), 2)}`;

        let minDate: string = fromDate;

        d.setDate(d.getDate() - 1);
        let maxDate: string = `${pad(d.getFullYear(), 4)}-${pad(d.getMonth() + 1, 2)}-${pad(d.getDate(), 2)}`;

        let createChart = (id: string, data: any) => new Chart(id, {
            type: 'bar',
            data: {
                datasets: [{
                    data: data.map((item: any) => ({ x: item.x, y: item.y.deepDuration })),
                    backgroundColor: '#2077a2',
                    label: 'DEEP (minutes)',
                    maxBarThickness: 5,
                },
                {
                    data: data.map((item: any) => ({ x: item.x, y: item.y.lightDuration })),
                    backgroundColor: '#29a5e5',
                    label: 'LIGHT (minutes)',
                    maxBarThickness: 5,
                },
                {
                    data: data.map((item: any) => ({ x: item.x, y: item.y.awakeDuration })),
                    backgroundColor: '#d270c3',
                    label: 'AWAKE (minutes)',
                    maxBarThickness: 5,
                }]
            },
            options: {
                animation: false,
                maintainAspectRatio: false,
                plugins: {
                    title: {
                        display: true,
                        text: 'Week View',
                    },
                    tooltip: {
                        mode: 'x'
                    }
                },
                scales: {
                    x: {
                        type: 'time',
                        time: {
                            displayFormats: {
                                day: 'MMM DD'
                            },
                            tooltipFormat: 'YYYY-MM-DD HH:mm',
                            unit: 'day',
                        },
                        min: minDate + 'T00:00:00.000',
                        max: maxDate + 'T23:59:59.999',
                        grid: {
                            offset: false
                        },
                        stacked: true,
                    },
                    y: {
                        beginAtZero: true,
                        position: 'right',
                        ticks: {
                            mirror: true,
                        },
                        stacked: true,
                    }
                }
            }
        });

        this.progressIndicatorService.progress = true;
        forkJoin([
            this.trackingService.getV2SleepDataOfWeek(this.accountId, minDate),
        ]).subscribe({
            next: ([data]) => {
                console.log('UserComponentV2.loadSleepWeekData.trackingService.getV2SleepDataOfWeek.data', data);
                this.progressIndicatorService.progress = false;
                //this.alertService.success('Success');

                let details = data.data.flatMap((sleep: any) => sleep.values.map((value: any) => ({ time: new Date(Date.parse(value.datetime.replace(/[\+\-]\d\d:\d\d/, ''))), type: value.value })))
                    .sort((a: any, b: any) => a.time.getTime() - b.time.getTime());

                let sleepData = [];
                let date = new Date(Date.parse(fromDate));
                date.setDate(date.getDate() - 1);
                let toTime = new Date(Date.parse(toDate)).getTime();
                while (date.getTime() < toTime) {

                    let period = 60;

                    let deepDuration = 0;
                    let lightDuration = 0;
                    let awakeDuration = 0;

                    let i = -1;
                    let j = -1;

                    let min = date.getTime();
                    let max = date.getTime() + (period * 60 * 1000);

                    for (let k = 0; k < details.length; k++) {
                        let t = details[k].time.getTime();
                        if ((t <= min) || (t > min && t < max && i == -1)) {
                            i = k;
                        }
                        if (t >= max) {
                            break;
                        }
                    }

                    for (let k = details.length - 1; k > -1; k--) {
                        let t = details[k].time.getTime();
                        if ((t >= max) || (t > min && t < max && j == -1)) {
                            j = k;
                        }
                        if (t < min) {
                            break;
                        }
                    }

                    if (i > -1 && j > i) {

                        let sub = details.slice(i, j + 1);

                        for (let k = 1; k < sub.length; k++) {

                            let prev = sub[k - 1];
                            let type = sub[k];

                            let start = Math.max(prev.time.getTime(), date.getTime());
                            let end = Math.min(type.time.getTime(), date.getTime() + (period * 60 * 1000));
                            let time = end - start;

                            if (prev.type == 'DEEP') {
                                deepDuration += time;
                            } else if (prev.type == 'LIGHT') {
                                lightDuration += time;
                            } else if (prev.type == 'BEGIN' || prev.type == 'AWAKE') {
                                awakeDuration += time;
                            }
                        }
                    }

                    deepDuration = Math.round(deepDuration / (1000 * 60));
                    lightDuration = Math.round(lightDuration / (1000 * 60));
                    awakeDuration = Math.round(awakeDuration / (1000 * 60));

                    while (deepDuration + lightDuration + awakeDuration > period) {
                        if (deepDuration == Math.max(deepDuration, lightDuration, awakeDuration)) {
                            deepDuration -= 1;
                        } else if (lightDuration == Math.max(deepDuration, lightDuration, awakeDuration)) {
                            lightDuration -= 1;
                        } else if (awakeDuration == Math.max(deepDuration, lightDuration, awakeDuration)) {
                            awakeDuration -= 1;
                        }
                    }

                    sleepData.push({ x: new Date(date), y: { deepDuration: deepDuration, lightDuration: lightDuration, awakeDuration: awakeDuration } });

                    date.setMinutes(date.getMinutes() + period);
                }
                sleepData = sleepData.filter(data => data.y.deepDuration > 0 || data.y.lightDuration > 0 || data.y.awakeDuration > 0);

                this.sleepWeekChart = createChart('sleepWeekChart', sleepData);

            },
            error: (error: any) => {
                console.log('UserComponentV2.loadSleepWeekData.trackingService.forkJoin.error', error);
                this.progressIndicatorService.progress = false;
                this.alertService.danger('Error');
            }
        });
    }
}
